import { Entity, Field } from 'typegraph';

@Entity({one: "userUser", many: "usersUser"})
export default class User {
	@Field()
	public id: string;

	@Field()
	public firstName: string;

	@Field()
	public lastName: string;

	@Field()
	public lastLoginDate: string;

}



// WEBPACK FOOTER //
// ./src/panels/userSummary/entities/User.ts